<template>
  <q-card square>
    <div class="title">{{ title }}</div> 
    <vue-highcharts :options="highchartOption"></vue-highcharts>
  </q-card>
</template>

<script>
import moment from 'moment'
import { Chart } from "highcharts-vue";
export default {
  components: {
    VueHighcharts: Chart,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type:Number,
      required: false
    },
    colors: {
      type: Array,
      required: false,
      default:() => ["#ea2c62", "#ff9a8c"],
    },
  },
  data() {
    return {
      highchartOption: {
        chart: {
          height: 250,
          type: "column",
          style: {
            fontFamily: "Roboto",
          },
        },
        title: {
          text: this.subtitle ? `Depreciation ${this.subtitle}%` : '',
        },
        xAxis: {
          categories: []
        },
        yAxis: {
          labels: {
            formatter: function () {
              return this.value.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
              });
            },
          },
        },
        tooltip: {
          split: true,
          pointFormat:
            '<span style="color:{series.color}">{series.name}</span>: <b>${point.y}</b><br/>',
        },
        colors: this.colors,
        credits: {
          enabled: false,
        },
        series: [
          {
            name: "Based on Projected Auction Value",
            data: [],
          },
          {
            name: "Based on Owner Depr. Assumption",
            data: [],
          }
        ],
      },
    };
  },
  methods: {
    _categories() {
      let chart_months = ["Now"];
      for (let index = 1; index < 25; index++) {
        const now = moment();
        const futureMonth = moment(now)
          .add(index, "M")
          .format("MMM Do YY");
        chart_months = [...chart_months, futureMonth];
      }
      this.highchartOption.xAxis.categories = chart_months;
    },
    analyisPusher(months) {
      var titles = ["based_estimated_payoff", "based_on_owner_depr"];
      for (let i = 0; i < titles.length; i++) {
        months.forEach((element) => {
          const j = titles[i];
          if ("based_estimated_payoff" === j) {
            this.highchartOption.series[0].data.push(element.based_estimated_payoff);
          } else if ("based_on_owner_depr" === j) {
            this.highchartOption.series[1].data.push(element.based_on_owner_depr);
          }
        });
      }
    },
  },
  created(){
    this._categories();
  },
  watch: {
    items: {
      deep: true,
      immediate: true,
      handler(n, o) {
        this.analyisPusher(n);
      },
    },
  },
};
</script>


<style lang="scss" scoped>
.title {
  font-size: 25px;
  font-weight: bold;
  color: #000;
  padding: 10px 0px;
  text-align: center;
}
</style>